import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { MarvColor, MarvColorPrimary } from '@marv/types';
import { environment } from '@app/environment';

@Injectable({
  providedIn: 'root'
})
export class MissionTypeService {
    
    constructor(
        private translateService: TranslateService
    ) { }
    
    getColor(missionCode: string): MarvColor{
        let missionType = environment.MISSIONS_TYPES.find(t => t.code === missionCode);
        return (missionType ? missionType.color : MarvColorPrimary);
    }
  
    getLabel(missionCode: string): string{
        let missionType = environment.MISSIONS_TYPES.find(t => t.code === missionCode);
        return (missionType ? this.translateService.instant(missionType.name) : '');
    }
}
